import { useProjectContentsContext } from '../contexts/ProjectContentsContext';

const useProjectContents = () => {
    return useProjectContentsContext();
}

export default useProjectContents
